export const TOKEN_KEY = 'token';

export const isAuthenticated = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(TOKEN_KEY) !== null;
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = (token: string) => {
  sessionStorage.setItem(TOKEN_KEY, token);
};